import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Checkbox, Grid, Table } from "semantic-ui-react";
import { CommonModal, CommonTable, InputText } from "../../../components";

import { useCreateRecipeIngredient, useGetRecipeIngredient } from "../../../api/recipe-ingredients";
import { useGetStaticRecipeIngredientData } from "../../../api/static-data";
import CommonSplitContainer from "../../../components/commonSplitContainer/CommonSplitContainer";
import MainBottomMultipleButtonView from "../../../components/mainBottomButtonView/MainBottomMultipleButtonView";
import { RecipeIngredientCol } from "../../../config/tableColConstant";

import { useForm } from "react-hook-form";
import { errorView, successMessage } from "../../../helpers/ErrorHandler";
import "./recipeIngredient.scss";

const RecipeIngredient = ({ visibleModal, setVisibleModal, companyDetails }: any) => {
  const [searchIngredient, setSearchIngredient] = useState<any>("");
  const [checkedRecipeIngredient, setCheckedRecipeIngredient] = useState<any>([]);

  const { data: recipeData } = useGetRecipeIngredient(companyDetails?.tenantId);
  const { data: staticRecipeIngredients } = useGetStaticRecipeIngredientData();

  const { mutate: createRecipeIngredient } = useCreateRecipeIngredient();

  useEffect(() => {
    setCheckedRecipeIngredient(recipeData?.map((item: any) => item?.ingredientId) || []);
  }, [recipeData]);

  const enableDisable = (item: any) => {
    setCheckedRecipeIngredient((prev: any) => {
      const prevArray = Array.isArray(prev) ? prev : [];
      if (prevArray.includes(item.value)) {
        return prevArray.filter((val: any) => val !== item.value);
      } else {
        return [...prevArray, item.value];
      }
    });
  };

  const confirmRecipeIngredient = () => {
    if (checkedRecipeIngredient.length === 0) {
      errorView("Please select at least one ingredient");
      return;
    }
    createRecipeIngredient(
      {
        ingredientIds: checkedRecipeIngredient,
        tenantId: companyDetails?.tenantId
      },
      {
        onSuccess: () => {
          setVisibleModal(false);
          successMessage("Recipe add and remove successfully");
        }
      }
    );
  };

  const filterStaticData = useMemo(() => {
    const re = new RegExp(_.escapeRegExp(searchIngredient), "i");
    let searchResult = _.filter(staticRecipeIngredients, (res: any) => {
      return re.test(res?.["text"]);
    });
    return searchResult.map((item: any) => {
      const matchingRecipe = recipeData?.find((recipe: any) => recipe.ingredientId === item.value);
      return {
        ...item,
        createdAt: matchingRecipe?.createdAt
      };
    });
  }, [searchIngredient, staticRecipeIngredients, recipeData]);

  const checkEnableRecipeIngredient = (item: any) => {
    return checkedRecipeIngredient.includes(item.value);
  };

  const { register } = useForm();

  const loadTableData = () => {
    return filterStaticData?.map((item: any, index: any) => {
      return (
        <Table.Row className="tbleR" key={index}>
          <Table.Cell className="recipeCheckBox">
            <Checkbox
              checked={checkEnableRecipeIngredient(item)}
              className="recipeCheckBoxContent"
              onClick={() => enableDisable(item)}
            />
            {item?.text}
          </Table.Cell>
          <Table.Cell>
            {item?.createdAt ? (
              <>{new Date(item?.createdAt).toISOString().slice(0, 19).replace("T", " ")}</>
            ) : null}
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <>
      <CommonModal
        modalOpenState={visibleModal}
        modalCloseState={() => {
          setVisibleModal(false);
        }}
        centered={true}
        title={`Add Ingredients for ${companyDetails?.name}`}
      >
        <CommonSplitContainer
          topChild={
            <Grid>
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <InputText
                  register={register}
                  name={`ingredientName`}
                  placeholder="Search"
                  defaultValues={searchIngredient}
                  onChangeFunction={(e: any) => {
                    setSearchIngredient(e.target.value);
                  }}
                />
              </Grid.Column>
              <Grid.Column computer={16} tablet={16} mobile={16} className="pt-0">
                <CommonTable tableHeaderData={RecipeIngredientCol} className="pesticideTable">
                  {loadTableData()}
                </CommonTable>
              </Grid.Column>
            </Grid>
          }
          bottomChild={
            <MainBottomMultipleButtonView
              leftButtons={[
                {
                  title: "Cancel",
                  onClick: () => setVisibleModal(false),
                  buttonOutLine: true
                }
              ]}
              rightButtons={[
                {
                  contentView: 16,
                  title: "Allow",
                  onClick: () => {
                    confirmRecipeIngredient();
                  },
                  buttonView: true
                }
              ]}
            />
          }
        />
      </CommonModal>
    </>
  );
};

export default RecipeIngredient;
